import { Feature } from '../models/feature';
import { SecondarySource } from '../models/secondarySource';
import { Subscription } from '../models/subscription';
import { SubscriptionSource } from '../models/subscriptionSource';

export const PAID_SUBSCRIPTION_TYPE = 'PAID';

export const parseSubscriptionId = (value?: string | null): number | undefined => {
  if (!value) {
    return undefined;
  }

  const subscriptionId = Number(value);
  return Number.isFinite(subscriptionId) && subscriptionId > 0
    ? subscriptionId
    : undefined;
};

// Any paid Recurly subscription, self-serve or direct-sale.
export const isPaidRecurlySubscription = (subscription?: Subscription) => (
  !!subscription
  && subscription.source === SubscriptionSource.RECURLY
  && subscription.subscriptionType === PAID_SUBSCRIPTION_TYPE
  && !!subscription.recurlySubUuId
);

export const isSelfServePaidSubscription = (subscription?: Subscription) => (
  isPaidRecurlySubscription(subscription)
  && subscription?.secondarySource !== SecondarySource.DIRECT_SALE
);

export const getTargetSelfServeSubscription = (
  subscriptions: Subscription[],
  feature: Feature,
  subscriptionId?: number,
) => {
  const selfServeSubscriptions = subscriptions.filter(isSelfServePaidSubscription);
  const targetedSubscription = subscriptionId
    ? selfServeSubscriptions.find(
      subscription => subscription.id === subscriptionId && subscription.feature === feature,
    )
    : undefined;

  return targetedSubscription
    ?? selfServeSubscriptions.find(subscription => subscription.feature === feature);
};
